import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { navigationMenuService } from '../services/navigationMenuService';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedMenuRouteProps {
  href: string;
  children: React.ReactNode;
}

export const ProtectedMenuRoute = ({ href, children }: ProtectedMenuRouteProps) => {
  const { user } = useAuth();
  const [isActive, setIsActive] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkRoute = async () => {
      try {
        // System route (channels) is always accessible
        if (href === '/') {
          setIsActive(true);
        } else {
          // Check route status with user's custom permissions
          const active = await navigationMenuService.isRouteActive(href, user?.id);
          setIsActive(active);
        }
      } catch (error) {
        console.error('Error checking route status:', error);
        // On error, allow access to avoid blocking user
        setIsActive(true);
      } finally {
        setLoading(false);
      }
    };

    checkRoute();
  }, [href, user?.id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (isActive === false) {
    // Redirect to home if route is not active
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
